import React, {useMemo} from "react";
import useZustandStore from "../hooks/useZustandStore";

const TOOLTIP_MAX_W = 260;
const EDGE_PAD = 16; // 屏幕边缘安全间距
const MAX_DEF_CHARS = 36; // 释义最大显示字数，超出则截断加 …

export default React.memo(function Tooltip({char, pos}) {
    const charDataMap = useZustandStore(state => state.charDataMap)
    const data = char ? charDataMap[char] : null;

    // 动态计算 tooltip 最大宽度：桌面端 260px，小屏自适应不超出视口
    const maxWidth = useMemo(() => {
        return Math.min(TOOLTIP_MAX_W, window.innerWidth - EDGE_PAD);
    }, []);

    if (!data || !pos) return null;

    const arrowBelow = pos.arrowBelow === true;
    const rawDef = data?.['Definition'] || '';
    const longDef = rawDef.length > MAX_DEF_CHARS;
    const definition = longDef
        ? rawDef.substring(0, MAX_DEF_CHARS) + '…'
        : rawDef;

    // 箭头偏移 clamp：箭头必须在框内（框宽度 == maxWidth，三角半宽 6px）
    const clamp = (v, lo, hi) => Math.max(lo, Math.min(v, hi));
    const safeArrow = clamp(pos.arrowOffset, 6, maxWidth - 6);

    return (
        <div
            className="fixed z-[1000] pointer-events-none"
            style={{left: pos.x + 'px', top: pos.y + 'px', width: maxWidth + 'px'}}
        >
            {/* 箭头在 tooltip 上方（tooltip 在字符下方时） */}
            {arrowBelow && (
                <div
                    className="w-0 h-0 border-x-[6px] border-x-transparent border-b-[6px] border-b-ink"
                    style={{position: 'absolute', left: safeArrow + 'px', transform: 'translateX(-50%)', top: -6}}
                />
            )}
            <div
                className="bg-ink text-paper px-4 py-2.5 rounded-md text-[13px] leading-relaxed shadow-2xl whitespace-nowrap overflow-hidden text-ellipsis"
                style={{ width: maxWidth + 'px' }}
            >
                <span className="font-display text-gold-light mr-2">{char}</span>
                <span className="text-paper-warm/60 mr-2 text-xs">{data?.['Pinyin']}</span>
                <span className="text-paper-warm/80">— {definition}</span>
            </div>
            {/* 箭头在 tooltip 下方（tooltip 在字符上方时，默认） */}
            {!arrowBelow && (
                <div
                    className="w-0 h-0 border-x-[6px] border-x-transparent border-t-[6px] border-t-ink"
                    style={{position: 'absolute', left: safeArrow + 'px', transform: 'translateX(-50%)', top: '100%'}}
                />
            )}
        </div>
    );
});